var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.menu)?_c('v-list',[_vm._l((_vm.menu),function(menuItem,id){return [(menuItem.children)?_c('category-menu',{key:id,attrs:{"menu":menuItem}}):_c('menu-item',{key:id,attrs:{"menu":menuItem}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }